<template>
   <div>
      <h2 :style="color.length > 0 && `color: ${color};`" class="h2 text-center">
         {{ header }}
      </h2>
      <p v-if="description" class="text-center modified-css">
         {{ description }}
      </p>
   </div>
</template>

<script>
export default {
   name: 'HeaderDescription',
   props: {
      header: {
         type: String,
         default: () => null,
      },
      description: {
         type: String,
         default: () => null,
      },
      color: {
         type: String,
         default: () => '',
      },
   },
};
</script>
<style lang="scss" scoped>
.home-page-container {
   .techlist-wrapper,
   .chart-slider-wrapper {
      h2 {
         max-width: 700px;
         margin: 0 auto;
      }
      p.text-center {
         max-width: 900px;
         margin: 2rem auto 8rem;
      }
   }
}
.product-gallery-page {
   .modified-css {
      margin-bottom: 0 !important;
   }
}
</style>
